document.addEventListener('DOMContentLoaded', function () {
  const tooltip = document.createElement('div');
  tooltip.id = 'global-tooltip';
  Object.assign(tooltip.style, {
    position: 'absolute',
    backgroundColor: 'rgba(60,60,60,0.95)',
    color: '#fff',
    padding: '6px 10px',
    borderRadius: '6px',
    fontSize: '14px',
    pointerEvents: 'none',
    opacity: 0,
    transition: 'opacity 0.2s ease, transform 0.2s ease',
    zIndex: 9999,
    maxWidth: '220px',
    lineHeight: '1.4'
  });
  document.body.appendChild(tooltip);

  // Use the Liquid-injected URL
  fetch(tooltipJsonUrl)
    .then(res => res.json())
    .then(tooltipMap => {
      document.querySelectorAll('a, .boxtable td span[data-href]').forEach(link => {
        let href = link.tagName.toLowerCase() === 'a' ? link.getAttribute('href') : link.getAttribute('data-href');
        if (!href) return;
        const cleanHref = href.split('?')[0].split('#')[0];
        const text = tooltipMap[cleanHref];
        if (!text) return;

        link.addEventListener('mouseenter', () => {
          tooltip.textContent = text;
          tooltip.style.opacity = 1;
          tooltip.style.transform = 'translateY(-5px)';
        });

        link.addEventListener('mousemove', (e) => {
          tooltip.style.top = (e.pageY + 15) + 'px';
          tooltip.style.left = (e.pageX + 15) + 'px';
        });

        link.addEventListener('mouseleave', () => {
          tooltip.style.opacity = 0;
          tooltip.style.transform = 'translateY(0)';
        });
      });
    })
    .catch(err => console.error('Error loading tooltip map:', err));
});
